import { useCurrentWorkspace } from '@/context/current-workspace';
import { AccountFeatureFlag, hasFeatureFlag } from '@/services/auth/feature-flags';
import { useSampleWorkspace } from '@/features/workspaces/sample-workspace';
import * as styles from './index.css';

/**
 * The stripe shown at the top of the page. The color is configured by the user
 */
export function WorkspaceStripe() {
  const workspace = useCurrentWorkspace();
  const { isSampleWorkspace } = useSampleWorkspace();

  const showStripe =
    !(
      hasFeatureFlag(AccountFeatureFlag.InteractiveDemoWorkspace) || hasFeatureFlag(AccountFeatureFlag.SampleWorkspace)
    ) && !isSampleWorkspace(workspace?.id);

  if (showStripe === false) {
    return null;
  }

  return <div className={styles.workspaceStripe} />;
}
